<template>
  <div class="chart-phone-wrapper">
    <div class="title">访问统计</div>
    <div class="date-change-box">
      <div>
        <el-select
          v-model="riskLevel"
          placeholder="请选择"
          size="medium"
          @change="handleChange"
        >
          <el-option
            v-for="item in optionsRiskLevel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-radio-group
          v-model="dateType"
          fill="#003d92"
          size="medium"
          @change="dateTypeChange"
        >
          <el-radio-button
            v-for="item in dateTypeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-model="customDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          v-if="showDatePicker"
          @change="getCustomDateData"
        ></el-date-picker>
      </div>
      <el-button size="small" :loading="exportBtnLoading" @click="exportXlsx"
        >数据导出</el-button
      >
    </div>
    <line-chart
      style="margin-bottom:32px;"
      :data="lineChartData"
      :pending="requestPending"
      :key="Math.random()"
    ></line-chart>
    <div class="pie-chart-wrapper">
      <right-pie
        :data="rightPieData"
        :rightPieLabelData="rightPieLabelData"
        :pending="requestPending"
        :color="pieColor"
        :key="Math.random()"
      ></right-pie>
      <left-pie
        :data="leftPieData"
        :leftPieLabelData="leftPieLabelData"
        :pending="requestPending"
        :key="Math.random()"
      ></left-pie>
    </div>
  </div>
</template>

<script>
import LineChart from "./lineChart.vue";
import LeftPie from "./leftPie.vue";
import RightPie from "./rightPie.vue";
import { exportExeclAndStyle } from "@/util/exportExecl";
import { getRiskPhoneData, exportRiskPhone } from "@/services/riskPhone";
import moment from "moment";
import {
  highColor,
  midColor,
  lowColor,
  interceptColor,
  optionsRiskLevel,
  dateTypeOption,
  RiskLevelMap
} from "./constants";
import { disposeLineEchart, disposeLineDataTime } from "./line";

export default {
  components: {
    LineChart,
    LeftPie,
    RightPie
  },
  data() {
    return {
      exportBtnLoading: false,
      dateType: "当天",
      lineChartData: {},
      leftPieData: [],
      leftPieLabelData: [],
      rightPieData: [],
      rightPieLabelData: [],
      requestPending: true,
      showDatePicker: false,
      customDate: [],
      pickerFirstDate: "", // 日期选择器选择的第一个时间
      riskLevel: RiskLevelMap.all,
      pieColor: [],
      optionsRiskLevel,
      dateTypeOption,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          // 日期选择器选择的点击选择事件
          this.pickerFirstDate = minDate.getTime(); // 点击下去第一个时间
          if (maxDate) {
            // 如果选择了第二个时间，重置pickerFirstDate
            this.pickerFirstDate = "";
          }
        },
        disabledDate: time => {
          if (this.pickerFirstDate !== "") {
            // 当只选择了第一个时间
            const day90 = (90 - 1) * 24 * 3600 * 1000;
            let maxTime = this.pickerFirstDate + day90;
            const minTime = this.pickerFirstDate - day90;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return (
              time.getTime() > maxTime ||
              time.getTime() < minTime ||
              time.getTime() < new Date("2020-07-07").getTime()
            );
          }
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("2020-07-07").getTime()
          );
        }
      }
    };
  },
  methods: {
    formateDate(momentStr) {
      return parseInt(new Date(momentStr).getTime() / 1000);
    },

    getStartTimeAndEndTime(type) {
      let params = {
        start_date: "",
        end_date: this.formateDate(moment().format("YYYY-MM-DD"))
      };
      if (type === "当天") {
        this.showDatePicker = false;
        params.start_date = this.formateDate(moment().format("YYYY-MM-DD"));
      } else if (type === "最近7天") {
        this.showDatePicker = false;
        params.start_date = this.formateDate(
          moment()
            .add(-7, "d")
            .format("YYYY-MM-DD")
        );
      } else if (type === "最近三十天") {
        this.showDatePicker = false;
        params.start_date = this.formateDate(
          moment()
            .add(-30, "d")
            .format("YYYY-MM-DD HH:mm:ss")
        );
      } else if (type === "自定义") {
        this.showDatePicker = true;
        this.customDate = [];
        return;
      }
      return params;
    },

    /**
     * 处理表格数据
     */
    disposeExeclData(sheetdata) {
      if (Array.isArray(sheetdata)) {
        let result = [];
        result.push(Object.keys(sheetdata[0]));
        sheetdata.map(item => {
          result.push(Object.values(item));
        });
        return result;
      }
    },

    /**
     * 导出数据
     */
    async exportXlsx() {
      this.exportBtnLoading = true;
      let params = {
        risk_level: this.riskLevel,
        start_date: "",
        end_date: ""
      };
      if (this.dateType === "自定义") {
        params = {
          ...params,
          start_date: this.formateDate(moment().format(this.customDate[0])),
          end_date: this.formateDate(moment().format(this.customDate[1]))
        };
      } else {
        params = {
          ...params,
          start_date: this.getStartTimeAndEndTime(this.dateType).start_date,
          end_date: this.getStartTimeAndEndTime(this.dateType).end_date
        };
      }
      const res = await exportRiskPhone(params);
      if (res.status === 200) {
        const { sheet1, sheet2, sheet3 } = res.data;
        let sheet1data = this.disposeExeclData(sheet1);
        let sheet2data = this.disposeExeclData(sheet2);
        let sheet3data = this.disposeExeclData(sheet3);
        try {
          exportExeclAndStyle(sheet1data, sheet2data, sheet3data);
          this.$message.success("导出成功");
        } catch (error) {
          this.$message.error("导出失败");
        }
      }
      this.exportBtnLoading = false;
    },

    /**
     * 单选按钮组改变事件
     */
    dateTypeChange(label) {
      if (label === "自定义") {
        this.showDatePicker = true;
        return;
      }
      let params = {
        risk_level: this.riskLevel,
        start_date: this.getStartTimeAndEndTime(label).start_date,
        end_date: this.getStartTimeAndEndTime(label).end_date
      };
      this.fetchData(params);
    },

    /**
     * 请求数据
     */
    async fetchData(params) {
      this.requestPending = true;
      const res = await getRiskPhoneData(params);
      this.handleSetEchartData(res);
    },

    /**
     * 获取自定义日期数据
     */
    async getCustomDateData(value) {
      if (!value) return;
      this.fetchData({
        risk_level: this.riskLevel,
        start_date: this.formateDate(moment().format(value[0])),
        end_date: this.formateDate(moment().format(value[1]))
      });
    },

    /**
     * 统一调取各个图表处理数据的方法
     * @param res: 接口返回数据
     * @param isToday: 是否为获取当天的数据，x轴处理不同
     */
    handleSetEchartData(res) {
      this.setDataforLineEchart(res.data.risk_info_list);
      this.setDataforLeftEchart(res.data.req_statistic);
      this.setDataforRightEchart(res.data.risk_distributed);
      this.requestPending = false;
    },

    /**
     * 处理折线图表数据
     */
    setDataforLineEchart(data) {
      const xAxisData = [];
      const seriesData = {};
      data.forEach(item => {
        for (const k in item) {
          xAxisData.push(k);
          item[k].forEach(innerItem => {
            if (!seriesData[innerItem.key]) {
              seriesData[innerItem.key] = [];
            }
            seriesData[innerItem.key].push(innerItem.value);
          });
        }
      });
      this.lineChartData = {
        xAxisData: disposeLineDataTime(xAxisData),
        seriesData: disposeLineEchart(this.riskLevel, seriesData)
      };
    },

    /**
     * 处理左边饼图数据
     * @param data: Array<{count:number,tag:string}>
     */
    async setDataforLeftEchart(data) {
      this.leftPieLabelData = data.map(i => i.key);
      this.leftPieData = data.map(i => {
        return {
          value: i.value,
          name: i.key
        };
      });
    },

    getColorIndex(data) {
      let high = data.filter(i => i.key.includes("高风险")).length;
      let middle = data.filter(i => i.key.includes("中风险")).length;
      let low = data.filter(i => i.key.includes("低风险")).length;

      let _highColor = highColor.slice(0, high);
      let _middleColor = midColor.slice(0, middle);
      let _lowColor = lowColor.slice(0, low);
      return []
        .concat(_highColor)
        .concat(_middleColor)
        .concat(_lowColor)
        .concat(interceptColor);
    },

    /**
     * 处理右边饼图数据
     * @param data: Array<{count:number,risk:string}>
     */
    async setDataforRightEchart(data) {
      if (data === null || data === undefined) {
        this.rightPieLabelData = [];
        this.rightPieData = [];
        return;
      }
      this.rightPieLabelData = data.map(i => i.key);
      this.rightPieData = data.map(i => {
        return {
          value: i.value,
          name: i.key
        };
      });
      switch (this.riskLevel) {
        case RiskLevelMap.high:
          this.pieColor = [].concat(highColor).concat(interceptColor);
          break;
        case RiskLevelMap.mid:
          this.pieColor = [].concat(midColor).concat(interceptColor);
          break;
        case RiskLevelMap.low:
          this.pieColor = [].concat(lowColor).concat(interceptColor);
          break;
        default:
          this.pieColor = this.getColorIndex(data);
          break;
      }
    },

    /**
     * 风险等级选择
     */
    handleChange() {
      let params = {
        risk_level: this.riskLevel,
        start_date: "",
        end_date: ""
      };

      if (this.dateType === "自定义") {
        params = {
          ...params,
          start_date: this.formateDate(moment().format(this.customDate[0])),
          end_date: this.formateDate(moment().format(this.customDate[1]))
        };
      } else {
        params = {
          ...params,
          start_date: this.getStartTimeAndEndTime(this.dateType).start_date,
          end_date: this.getStartTimeAndEndTime(this.dateType).end_date
        };
      }

      this.fetchData(params);
    }
  },
  created() {
    this.dateTypeChange("当天");
  }
};
</script>

<style lang="scss" scoped>
.chart-phone-wrapper {
  margin-top: 40px;
  .title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(112, 119, 141, 1);
    line-height: 22px;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  .date-change-box {
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .el-radio-group {
    margin-right: 20px;
    margin-left: 10px;
  }
  .pie-chart-wrapper {
    display: flex;
    justify-content: space-between;
  }
}
</style>
